import RegisterCURPError from './RegisterCURPError';
class InvalidCURP extends RegisterCURPError {
    constructor(curp) {
        super(`Investor try to register "${curp}" is not valid`);
    }
}
export default InvalidCURP;
